import { Box } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import { tokens } from "styles/Tokens";
import Spinner from "../Spinner/Spinner";
import Typography from "../Typography";
import "./Scroller.scss";

interface Props {
  children: any;
  dataLength: number;
  loadMore?: any;
  totalList?: number;
  label: string;
  scrollableTarget?: string;
  footerStyle?: any;
}

function Scroller(props: Props) {
  const { children, dataLength, loadMore, totalList = dataLength, label, scrollableTarget, footerStyle } = props;

  return (
    <InfiniteScroll
      dataLength={dataLength}
      next={loadMore}
      hasMore={dataLength < totalList}
      scrollableTarget={scrollableTarget}
      className="infinite-scrollbar-component"
      loader={
        <Box
          display={"flex"}
          flexDirection="column"
          alignItems="center"
          justifyContent={"center"}
          className="infinite-scrollbar-box-wrapper"
        >
          <Spinner />
          <Box display={"flex"} marginTop="25px" gap={"5px"} flexDirection="row">
            <Typography color={tokens.Text.General.Color} variant={"label"} children={"Showing"}></Typography>

            <Typography
              color={tokens.Text.General.Color}
              variant={"label"}
              showBold
              children={`${dataLength} of ${totalList} ${label}`}
            ></Typography>
          </Box>
        </Box>
      }
      endMessage={
        dataLength ? (
          <Box
            display={"flex"}
            justifyContent="center"
            alignItems={"center"}
            className="count-loaded"
            gap={"5px"}
            flexDirection="row"
            sx={{ ...footerStyle }}
          >
            <Typography color={tokens.Text.General.Color} variant={"label"} children={"Showing"}></Typography>

            <Typography
              color={tokens.Text.General.Color}
              variant={"label"}
              showBold
              children={`${dataLength} of ${totalList} ${label}`}
            ></Typography>
          </Box>
        ) : null
      }
    >
      {children}
    </InfiniteScroll>
  );
}

export default Scroller;
